import { Minus, Plus } from '../../../ui/icons';
import { useHaptics } from '../../../../hooks/useHaptics';

export function ScoreStepper({ value, onChange }: { value: number; onChange: (v: number) => void }) {
  const { impact } = useHaptics();
  const step = (d: number) => {
    impact('selection');
    onChange(Math.max(0, Math.min(9, value + d)));
  };
  return (
    <div className="flex items-center gap-2.5">
      <button type="button" onClick={() => step(-1)} className="tap grid h-7 w-7 place-items-center rounded-full border border-black/10 bg-card" aria-label="Decrease">
        <Minus width={12} height={12} strokeWidth={3} className="text-ink2" />
      </button>
      <span className="num w-[22px] text-center text-[26px] font-extrabold leading-none text-ink">{value}</span>
      <button type="button" onClick={() => step(1)} className="tap grid h-7 w-7 place-items-center rounded-full bg-night" aria-label="Increase">
        <Plus width={12} height={12} strokeWidth={3} className="text-white" />
      </button>
    </div>
  );
}
